import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import { StockTextContent } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/CaseSizeText/__internal__/StockTextContent";
export var Caseline = function(param) {
    var isLoggedIn = param.isLoggedIn, caseSizeText = param.caseSizeText, availabilityText = param.availabilityText, limitedStockText = param.limitedStockText, isSalesPaused = param.isSalesPaused;
    var eligibleForInventoryText = isLoggedIn && (caseSizeText || availabilityText || limitedStockText || isSalesPaused);
    if (eligibleForInventoryText) {
        return /*#__PURE__*/ _jsxs(Row, {
            align: "baseline",
            style: {
                width: "100%",
                flexWrap: "wrap"
            },
            children: [
                caseSizeText ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraphSansRegular",
                            color: Core.text.subdued,
                            children: caseSizeText
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            width: "1x"
                        })
                    ]
                }) : null,
                availabilityText ? /*#__PURE__*/ _jsx(Typography, {
                    color: Core.text.critical,
                    children: availabilityText
                }) : /*#__PURE__*/ _jsx(StockTextContent, {
                    limitedStockText: limitedStockText,
                    isSalesPaused: isSalesPaused
                })
            ]
        });
    }
    return null;
};
